import React from 'react'
import GearTracker from './gear/GearTracker'
import FriendWidget from './friends/FriendWidget'
import UserSummary from './summary/UserSummary'
import UserStatement from './summary/UserStatement'

export default function HomeSidebar () {
  return (
    <div>
      <UserSummary />
      <UserStatement />
      <GearTracker />
      <FriendWidget />
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/home/HomeSidebar.jsx